let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eJir9")).then(() => parcelRequire('hkRdu'));